import React, { useState, useEffect } from 'react';
import '../css/App.css';

import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import ActionMenu from '@mui/icons-material/Menu';
import LinearProgress from '@material-ui/core/LinearProgress';
import Hidden from '@material-ui/core/Hidden';
import ActionLogout from '@mui/icons-material/PowerSettingsNew';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import BarChartIcon from '@mui/icons-material/BarChart';
import { MuiThemeProvider, withStyles, withTheme } from '@material-ui/core/styles';
import logo from '../images/LogoBlanc.png';
import { Link, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import theme from './Theme';
import BarListSidebarView from "./BarListSidebarView";
import { request } from '../util';

import { translate } from "../i18n/customI18nProvider";
import RefreshIcon from '@mui/icons-material/Refresh';
import config from '../config';
import { clear, getRight, getToken, removePeriodID, setPeriodID } from '../services/storage';
import { EventIcon } from '../forms/Events';

// --- Styles identiques à votre Menu.js (compacts en hauteur et alignés) ---
const baseItemStyle = {
    marginLeft: '8px',
    marginRight: '8px',
    width: 'calc(100% - 16px)',
    borderRadius: '6px',
    paddingLeft: '8px',
    paddingTop: '6px',
    paddingBottom: '6px',
    minHeight: 'auto',
    transition: 'all 0.2s ease',
};

const activeItemStyle = {
    ...baseItemStyle,
    backgroundColor: '#08607e',
    color: '#ffffff',
};

const Header = (props) => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [periodId, setPeriodId] = useState('');
    const location = useLocation();

    useEffect(() => {
        removePeriodID();
        const initInfomaniak = async () => {
            const token = getToken();
            const right = getRight();
            if (token && (right < config.permissions.SUPERADMIN.value) && (right >= config.permissions.ADMIN.value) && !props.noSide) {
                let infomaniak_info = await request('/events/parameter/infomaniak', 'GET', null);
                if (infomaniak_info.error) {
                    alert(infomaniak_info.error);
                    return;
                }
                let infomaniak = infomaniak_info.infomaniak;
                setPeriodId(infomaniak?.PERIOD_ID);
                if (infomaniak?.PERIOD_ID) {
                    setPeriodID(infomaniak.PERIOD_ID);
                }
            }
        };
        initInfomaniak();
    }, [props.noSide]);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleLogout = () => {
        Swal.fire({
            title: 'Are you sure you want to logout?',
            showCancelButton: true,
            confirmButtonText: 'Logout',
            confirmButtonColor: config.baseColor
        }).then((result) => {
            if (result.isConfirmed) {
                clear();
                window.location.replace('/login');
            }
        });
    };

    const refreshClicked = () => {
        if (props.refreshClicked) {
            props.refreshClicked();
        }
    };

    const eventName = props.name || '';
    const items = props.items ? props.items : [];

    const isStatisticsActive = location.pathname === props.home;
    const isAdminActive = location.pathname === '/admin';

    const statistics = (
        <ListItem 
            button
            component={Link}
            to={props.home}
            style={isStatisticsActive ? activeItemStyle : baseItemStyle}
        >
            <ListItemIcon style={{ minWidth: '40px', color: isStatisticsActive ? '#ffffff' : '#495057' }}>
                <BarChartIcon />
            </ListItemIcon>
            <ListItemText 
                primary={translate('custom.statistics')} 
                primaryTypographyProps={{ style: { color: isStatisticsActive ? '#ffffff' : '#000000' } }}
            />
        </ListItem>
    );

    const admin = (
        <ListItem 
            button
            component={Link}
            to='/admin'
            style={isAdminActive ? activeItemStyle : baseItemStyle}
        >
            <ListItemIcon style={{ minWidth: '40px', color: isAdminActive ? '#ffffff' : '#495057' }}>
                <EventIcon />
            </ListItemIcon>
            <ListItemText 
                primary={translate('custom.parameters')} 
                primaryTypographyProps={{ style: { color: isAdminActive ? '#ffffff' : '#000000' } }}
            />
        </ListItem>
    );

    const logout = (props.logout !== false) ? (
        <ListItem 
            button 
            onClick={handleLogout}
            style={baseItemStyle}
        >
            <ListItemIcon style={{ minWidth: '40px', color: '#495057' }}>
                <ActionLogout />
            </ListItemIcon>
            <ListItemText 
                primary={translate('custom.logout')} 
                primaryTypographyProps={{ style: { color: '#000000' } }}
            />
        </ListItem>
    ) : null;

    const list = (
        <List style={{ width: 220, backgroundColor: 'transparent' }}>
            <ListItem style={{ backgroundColor: 'transparent', paddingLeft: '16px' }}>
                <ListItemText
                    primary="JM Contactless"
                    secondary={eventName}
                />
            </ListItem>
            <Divider style={{ backgroundColor: '#495057' }} />
            {statistics}
            {admin}
            <Divider style={{ backgroundColor: '#495057' }} />
            <BarListSidebarView items={items} />
            <Divider style={{ backgroundColor: '#495057' }} />
            {logout}
            <Divider style={{ backgroundColor: '#495057' }} />
        </List>
    );

    return (
        <MuiThemeProvider theme={theme}>
            <div className={props.noSide ? null : props.classes.container}>
                <div className="noPrint">
                    <AppBar position="fixed">
                        <div className={props.noSide ? props.classes.headerNoSide : props.classes.header}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                {props.noSide ? null : (
                                    <Hidden mdUp>
                                        <div style={{ width: 40 }}>
                                            <IconButton onClick={handleDrawerToggle}>
                                                <ActionMenu style={{ color: "white" }} />
                                            </IconButton>
                                        </div>
                                    </Hidden>
                                )}
                                <p style={{ fontSize: 20, marginLeft: 30, color: "white" }}>{props.title}</p>
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                {props.refreshClicked && (
                                    <RefreshIcon
                                        style={{
                                            cursor: "pointer",
                                            color: "white"
                                        }}
                                        onClick={refreshClicked}
                                    />
                                )}
                                <img alt="logo" style={{ height: "40px", marginLeft: "20px", marginRight: "20px" }} src={logo} />
                            </div>
                        </div>
                        {props.loading ? <LinearProgress color="secondary" /> : null}
                    </AppBar>
                </div>
                {props.noSide ? null : (
                    <div>
                        <Hidden mdUp>
                            <SwipeableDrawer
                                variant="temporary"
                                onOpen={() => setMobileOpen(true)}
                                onClose={() => setMobileOpen(false)}
                                onClick={handleDrawerToggle}
                                open={mobileOpen}
                            >
                                {list}
                            </SwipeableDrawer>
                        </Hidden>
                        <Hidden smDown implementation="css">
                            <Drawer variant="permanent">
                                {list}
                            </Drawer>
                        </Hidden>
                    </div>
                )}
                <div className="container-center">
                    <div className={props.classes.center} id="container-center">
                        {props.children}
                    </div>
                </div>
            </div>
        </MuiThemeProvider>
    );
};

const styles = theme => ({
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        [theme.breakpoints.up('md')]: {
            marginLeft: 220
        }
    },
    headerNoSide: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    center: {
        marginTop: 64,
        margin: "auto",
        textAlign: "left",
        width: "100%",
        maxWidth: "1000px",
        backgroundColor: "#fff",
        [theme.breakpoints.up('md')]: {
            padding: 30
        }
    },
    container: {
        [theme.breakpoints.up('md')]: {
            marginLeft: 220
        },
    }
});

export default withTheme(withStyles(styles)(Header));